import { render, staticRenderFns } from "./zhiboclass.vue?vue&type=template&id=b279afde&scoped=true"
import script from "./zhiboclass.vue?vue&type=script&lang=js"
export * from "./zhiboclass.vue?vue&type=script&lang=js"
import style0 from "./zhiboclass.vue?vue&type=style&index=0&id=b279afde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b279afde",
  null
  
)

export default component.exports